import { fetchKitchenCoupons } from "../../../services/order.api";

export const couponFetchApi = (kitchenId) => fetchKitchenCoupons(kitchenId);
